<?xml version="1.0" encoding="UTF-8"?>
<svg id="e" data-name="ICONS" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
  <path d="m.82095,6.14616L6.1465.82091c.31502-.315.85364-.09183.85354.35367l-.00107,5.07559c-.00009.41417-.33587.74986-.75004.74984l-5.07447-.00028c-.44545-.00002-.6685-.53859-.35352-.85356Z" fill="var(--iconPrimary, #222)" stroke-width="0"/>
</svg>